// src/services/priceApprovalService.js
// FIXED: Removed all broken [api.post](http://api.post) and [response.data](http://response.data) markdown link syntax

import api from './api';

const resolveDisplayStatus = (inspection) => {
  const srStatus = inspection.sell_request?.status;
  if (srStatus === 'price_accepted') return 'price_accepted';
  if (srStatus === 'offer_rejected') return 'offer_rejected';
  return inspection.status;
};

const priceApprovalService = {
  getPricedInspections: async () => {
    const response = await api.get('/car_inspections');
    const all = response.data?.data || [];
    const relevant = all.filter((i) => {
      const srStatus = i.sell_request?.status;
      const iStatus  = i.status;
      return (
        ['priced', 'price_accepted', 'offer_rejected'].includes(iStatus) ||
        ['price_accepted', 'offer_rejected'].includes(srStatus)
      );
    });
    return relevant.map((i) => ({ ...i, displayStatus: resolveDisplayStatus(i) }));
  },

  acceptPrice: async (sellRequestId) => {
    const response = await api.post(
      `/seller/sell_requests/${sellRequestId}/price_acceptance`,
      { decision: 'accept' }
    );
    return response.data;
  },

  rejectPrice: async (sellRequestId) => {
    const response = await api.post(
      `/seller/sell_requests/${sellRequestId}/price_acceptance`,
      { decision: 'reject' }
    );
    return response.data;
  },
};

export default priceApprovalService;